module.exports = __webpack_public_path__ + "exchangeIntegral.png?92d3bf45db46d703024af640e6c79bf5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/exchangeIntegral.png
// module id = 15
// module chunks = 0